import { useDispatch } from 'react-redux';
import { StyledEnterTelContainer, StyledOtpContainer } from '../../components/container/styles';
import React, { useEffect, useState } from 'react';
import { setTitle } from '../../redux/title/action';
import { RenderForm } from '../../components/forms';
import { FORM_OTP, FORM_TEL } from './form';
import { useGetEnterTelList } from './hooks/useGetEnterTelList';
import { ButtonTheme } from '../../components/buttons';
import { ContainerButton } from '../../styles/global-style';
import { TextSmall } from '../../components/text';
import { Timer } from './time';
import { PolicyModal } from './modals/PolicyModal';
import { Spin } from 'antd';

export const EnterTel = () => {
  const dispatch = useDispatch();
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false);
  const [isPolicyOpen, setIsPolicyOpen] = useState(true);

  const {
    control,
    getValues,
    setValue,
    onSubmitTel,
    handleSubmit,
    isSubmit,
    otpResponse,
    onSubmitOtp,
    isLoadingCallOtp,
    isLoadingVerifyOtp,
  } = useGetEnterTelList();

  useEffect(() => {
    dispatch(setTitle('ลงทะเบียนเบอร์โทรศัพท์'));
  }, [dispatch]);

  return (
    <>
      <PolicyModal
        open={isPolicyOpen}
        onToggle={() => setIsPolicyOpen(false)}
        onAccept={() => {
          setIsPolicyAccepted(true);
          setIsPolicyOpen(false);
        }}
      />
      {isPolicyAccepted && (
        <StyledEnterTelContainer>
          <Spin spinning={isLoadingCallOtp || isLoadingVerifyOtp}>
            <RenderForm
              control={control}
              getValues={getValues}
              setValue={setValue}
              forms={FORM_TEL()}
            />
            <ContainerButton center>
              <ButtonTheme
                useFor="GETOTP"
                title="รับรหัส OTP"
                onClick={handleSubmit(onSubmitTel)}
                disabled={isSubmit}
              />
              {isSubmit && (
                <StyledOtpContainer>
                  <TextSmall
                    text={
                      <>
                        <span>รหัส OTP จะหมดอายุใน</span> <Timer />
                      </>
                    }
                  />
                  <div style={{ marginTop: '30px' }}>
                    <RenderForm
                      control={control}
                      getValues={getValues}
                      setValue={setValue}
                      forms={FORM_OTP(otpResponse?.item?.otpRef || '')}
                    />
                    <ButtonTheme useFor="CONFIRM_OTP" onClick={handleSubmit(onSubmitOtp)} />
                  </div>
                </StyledOtpContainer>
              )}
            </ContainerButton>
          </Spin>
        </StyledEnterTelContainer>
      )}
    </>
  );
};
